import 'nprogress/nprogress.css'
import './styles.module.css'
import NProgress from 'nprogress'
import { useEffect } from 'react'

// NProgressの設定
NProgress.configure({
  showSpinner: false,
  minimum: 0.1,
  speed: 300,
})

/**
 * Suspenseのfallbackとして使用するコンポーネント
 * マウント時にプログレスバーを開始し、アンマウント時に終了する
 */
export function TopProgressBar() {
  useEffect(() => {
    NProgress.start()
    return () => {
      NProgress.done()
    }
  }, [])

  return null
}
